{
  "name": "@uppy/tus",
  "description": "Resumable uploads for Uppy using Tus.io",
  "version": "5.0.1",
  "license": "MIT",
  "type": "module",
  "sideEffects": false,
  "scripts": {
    "build": "tsc --build tsconfig.build.json",
    "typecheck": "tsc --build",
    "test": "vitest run --environment=jsdom --silent='passed-only'"
  },
  "keywords": [
    "file uploader",
    "uppy",
    "uppy-plugin",
    "upload",
    "resumable",
    "tus"
  ],
  "homepage": "https://uppy.io",
  "bugs": {
    "url": "https://github.com/transloadit/uppy/issues"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/transloadit/uppy.git"
  },
  "files": [
    "src",
    "lib",
    "dist",
    "CHANGELOG.md"
  ],
  "exports": {
    ".": "./lib/index.js",
    "./package.json": "./package.json"
  },
  "dependencies": {
    "@uppy/companion-client": "workspace:^",
    "@uppy/utils": "workspace:^",
    "tus-js-client": "^4.2.3"
  },
  "devDependencies": {
    "@uppy/core": "workspace:^",
    "jsdom": "^26.1.0",
    "typescript": "^5.8.3",
    "vitest": "^3.2.4"
  },
  "peerDependencies": {
    "@uppy/core": "workspace:^"
  }
}
